<template>
  <div class="vip-info">
    <purchase
      v-if="id==1 && vipList.memberVip==1 || id==2 && vipList.memberVip==1||id==3 && vipList.memberVip==1"
      :id="id"
      :dataInfo="dataInfo"
      @submit="submit"
    ></purchase>
    <noPurchase :id="id" v-else></noPurchase>
    <div class="qCode" @click="openPopup" v-if="dataInfo.isSignUp==1">
      <img :src="dataInfo.qrCode" />
      <span>点击进群</span>
    </div>
    <!-- memberVip	是否会员（0:不是 1：会员）v-if="vipList.memberVip==0" -->
    <div class="vip-footer" @click="paymentBtn" v-if="vipList.memberVip==0">
      <div class="footer">立即开通</div>
    </div>
    <popup v-if="popupFlag" :qrCodeData="dataInfo.qrCode" @openPopup="openPopup"></popup>
  </div>
</template>
  
<script>
import purchase from './components/purchase.vue'
import noPurchase from './components/no-purchase.vue'
import popup from './components/popup.vue'
import { getShareInfo } from '@/utils/storage'
import { wxShare } from '@/utils/wx-config'
export default {
  components: {
    purchase,
    noPurchase,
    popup,
  },
  data() {
    return {
      id: '',
      popupFlag: false,
      dataInfo: {},
      vipList: {},
      qrCodeData: {},
    }
  },
  created() {
    this.id = this.$route.query.id
    this.isMemberVip()
    this.getInfo()
  },
  mounted() {
    let shareInfo = getShareInfo()
    wxShare({ shareInfo })
  },
  methods: {
    async getInfo() {
      let res = await this.api.vip.getMembernterestAction(this.id)
      if (res && res.code == 200) {
        this.dataInfo = res.data
      }
    },
    async isMemberVip() {
      let res = await this.api.vip.isMemberVip()
      if (res && res.code == 200) {
        this.vipList = res.data
        this.$forceUpdate()
      }
    },
    submit() {
      this.signUpterestAction()
    },
    openPopup(data) {
      if (data == 1) {
        this.popupFlag = false
      } else {
        this.popupFlag = true
      }
    },
    async signUpterestAction() {
      let data = {
        interestId: this.dataInfo.interestId,
        actId: this.dataInfo.id,
      }
      let res = await this.api.vip.signUpterestAction(data)
      if (res && res.code == 200) {
        setTimeout(() => {
          this.popupFlag = true
        }, 200)
        this.$forceUpdate()
      }
    },
    paymentBtn() {
      this.$router.push({
        name: 'payment',
        query: {
          goodsType: this.constants.goodsType.vip,
          adminId: this.adminId,
          id: this.id
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.vip-info {
  padding: 0 32px;
  background: url(../../assets/images/vip/black.png) no-repeat 0 -130px;
  background-size: 100% auto;
  .qCode {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: 300px;
    right: 80px;
    img {
      width: 60px;
      height: 60px;
      margin-bottom: 10px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
      color: #ff6c2c;
    }
  }
  .vip-footer {
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 120px;
    background-color: #ffffff;
    .footer {
      width: 560px;
      height: 80px;
      margin: 0 auto;
      line-height: 80px;
      font-size: 32px;
      font-weight: 600;
      color: #714a33;
      background: linear-gradient(90deg, #ffe1c4 0%, #f5af68 100%);
      border-radius: 40px;
      border-image: linear-gradient(
          180deg,
          rgba(255, 243, 228, 1),
          rgba(226, 163, 104, 1)
        )
        2 2;
    }
  }
}
</style>
